<template>
  <v-card flat outlined class="ratio-card">
    <v-card-title class="subtitle-2 font-weight-bold py-3 px-4 flex-shrink-0">
      <v-icon small left>mdi-chart-bar</v-icon>
      Online ratio by group
    </v-card-title>
    <v-divider />
    <div class="ratio-card__body">
      <div class="ratio-card__body__scroller">
        <div
          v-for="ratio in ratiosWithPercent"
          v-bind:key="ratio.name"
          class="ratio-row px-4 py-3"
          v-bind:class="{ 'ratio-row--active': selectedId === ratio.id }"
          style="cursor:pointer"
          v-on:click="$emit('select', ratio.id === selectedId ? null : ratio.id)"
        >
          <div class="d-flex justify-space-between caption mb-1">
            <span class="ratio-name">{{ ratio.name }}</span>
            <span class="text--secondary">{{ ratio.online }}/{{ ratio.total }}</span>
          </div>
          <v-progress-linear
            v-bind:value="ratio.percent"
            v-bind:color="barColor(ratio.percent)"
            rounded
            height="7"
          />
        </div>
        <div v-if="!ratiosWithPercent.length" class="text-center py-6">
          <v-icon large class="text--disabled">mdi-chart-bar</v-icon>
          <div class="caption text--disabled mt-2">No data</div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'OnlineRatioChart',

  props: {
    ratios:     { type: Array,  default: () => [] },
    selectedId: { type: Number, default: null }
  },

  computed: {
    ratiosWithPercent() {
      return this.ratios.map(r => ({
        ...r,
        percent: r.total > 0 ? Math.round((r.online / r.total) * 100) : 0
      }));
    }
  },

  methods: {
    barColor(percent) {
      if (percent >= 80) return 'success';
      if (percent >= 50) return 'warning';
      return 'error';
    }
  }
};
</script>

<style scoped>
.ratio-card           { display: flex; flex-direction: column; height: 100%; min-height: 0; overflow: hidden; }
.ratio-card__body     { flex: 1; overflow-y: hidden; height: 100%; padding-bottom: 12px; position: relative; }
.ratio-card__body__scroller { height: 100%; overflow-y: auto; position: absolute; inset: 0; padding-bottom: 12px; }

.ratio-row--active  { background: rgba(128,128,128,.1); border-radius: 6px; }

.ratio-name        {
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
